import { takeLatest } from "redux-saga/effects"
import {
  EditFrontlineUsersDataAction,
  getFrontlineUsersDataAction,
  getFrontlineUsersListAction,
  exportFrontlineUsersAction,
  deleteUserAction,
  getUserTypeListAction,
  updateUserStatusAction,
  uploadFrontlineUserAction,
  uploadFrontlineBulkUserAction,
  getAdminUsersListAction,
  uploadAdminUserAction,
  getUserMainListAction,
  getRoleUsersListAction,
  getNewRestaurantListAction,
  getAdminUsersDataAction,
  EditAdminUsersDataAction,
  updateAdminUserStatusAction,
  uploadFrontlineBulkUserAdminAction,
  getDashboardStatsAction,
  getVersionListAction,
  addVersionAction,
  getVersionDataAction,
  updateVersionAction,
  deleteVersionAction,
  addNotificationAction,
  getNotificationListAction,
  deleteNotificationAction,
  sendNotificationAction,
  getNotificationsAction,
  EditNotificationAction,
  uploadNotificationImageAction,
  addGiftCardAction,
  getGiftCardListAction,
  deleteGiftCardAction,
  getGiftCardsAction,
  EditGiftCardAction,
  uploadGiftCardImageAction,
  getGamificationDataAction,
  EditGamificationAction,
  getEventDataAction,
  addEventAction,
  deleteEventAction,
  getEventDetailsAction,
  editEventAction,
  addMenuImageAction,
  getMenuImageAction,
  uploadMenuImageAction,
  downloadMenuTemplateAction,
  getDynamicMenuFieldsAction,
  deleteMenuFieldAction,
  createDynamicMenuFieldsAction,
  editDynamicMenuFieldsAction,
  sendInviteAction,
  getUserRoleAction,
  getRoleDetailsAction,
  editRoleDetailsAction,
  addRoleDetailsAction,
  deleteRoleDetailsAction,
  addMenuCategoryAction,
  changeMenuOrderAction,
  getMenuCategoryDetailsAction,
  editMenuCategoryDetailsAction,
  deleteMenuCategoryAction,
  getHeaderNotificationAction,
  createHeaderNotificationAction,
  getTilesListAction,
  createTileAction,
  enableDisableTilesAction,
  getTileDetailsAction,
  updateTileAction,
  deleteTileAction,
  reorderTilesAction,
  getRecommendationCategoryListAction,
  getRecommendedCategoryDetailsAction,
  updateRecommendationCategoryDetailsAction,
  getWeeklyCategoryAction,
  uploadWeeklyCategoryImageAction,
  addWeeklyCategoryImageAction,
  addWeeklyCategoryAction,
  getAdvertisementsAction,
  getAdvertisementDetailsAction,
  addAdvertisementsAction,
  updateAdvertisementsAction,
  deleteAdvertisementsAction,
  editWeeklyCategoryAction,
  uploadPrivacyPolicyDocumentAction,
  getPrivacyPolicyAction,
  getNotableVipsAction,
  getNotableUsersAction,
  updateNotableUsersAction,
  getVipDetailsAction,
  approveVipAction,
  uploadVipImageAction,
  createNotableVipAction,
  updateNotableVipAction,
  getNotableVipGroupsAction,
  createNotableVipGroupAction,
  updateNotableVipGroupAction,
  deleteNotableVipGroupAction,
  getVipGroupDynamicFieldsAction,
  createVipGroupSectionAction,
  updateVipGroupSectionAction,
  deleteVipGroupSectionAction,
  createVipGroupFieldAction,
  updateVipGroupFieldAction,
  deleteVipGroupFieldAction,
  reorderVipGroupSectionsAction,
  getNotableGroupTypesAction,
  getAvataarPromptAction,
  updateAvataarPromptAction,
  getVipGroupFieldsAction,
  deleteNotableVipAction,
  uploadRewardImageAction,
  getTiersAction,
  createTierAction,
  updateTierAction,
  deleteTierAction,
  updateTierOrderAction,
  getCategoriesAction,
  createCategoryAction,
  updateCategoryAction,
  deleteCategoryAction,
  getCardTypesAction,
  getRewardsAction,
  createRewardAction,
  updateRewardAction,
  deleteRewardAction,
  reorderRewardsAction,
  setRewardSpreeQuantityAction,
  getSpreeWindowQuantitiesAction,
  uploadGiftCardCouponsAction,
  getGiftCardRedemptionsAction,
  getAllRedemptionsAction,
  changeRedemptionStatusAction,
  getRewardStateAction,
  updateRewardStateAction,
  getAnalyticsSummaryAction,
  exportAnalyticsAction,
  getSectionTypesAction,
  createSectionTypeAction,
  getSectionTypeDetailAction,
  updateSectionTypeAction,
  deleteSectionTypeAction,
  createSectionFieldAction,
  updateSectionFieldAction,
  deleteSectionFieldAction,
  reorderSectionTypesAction,
  reorderSectionFieldsAction,
  getPreshiftsAction,
  createPreshiftAction,
  getPreshiftDetailAction,
  updatePreshiftAction,
  deletePreshiftAction,
  publishPreshiftAction,
  unpublishPreshiftAction,
  updatePreshiftSectionDataAction,
  updateAllPreshiftSectionsAction,
  addItemsToSectionAction,
  removeItemFromSectionAction,
  uploadPreshiftMediaAction,
  reorderPreshiftSectionsAction,
  copyPreshiftAction,
  secondApproveVipAction,
  getCMSRestaurantListAction,
  getCMSRestaurantDetailAction,
  createCMSRestaurantAction,
  updateCMSRestaurantAction,
  getCMSRestaurantGroupListAction,
  getCMSRestaurantGroupDetailAction,
  createCMSRestaurantGroupAction,
  updateCMSRestaurantGroupAction,
  getCMSUsersForAssignmentAction,
  uploadCMSMediaAction,
  reorderCMSRestaurantsAction,
  getRaffleWinnersAction,
  updateRaffleWinnerPrizeClaimedAction,
  getVipCategoriesAction,
  getRewardsPermissionsAction,
  updateRewardsPermissionsAction,
  getShoppingSpreeWindowsAction,
  createShoppingSpreeWindowAction,
  updateShoppingSpreeWindowAction,
  deleteShoppingSpreeWindowAction
} from "../actions/user"
import {
  EditAdminUsersData,
  EditFrontlineUsersData,
  addVersionItems,
  deleteVersionItem,
  getAdminUsersData,
  getAdminUsersList,
  getAppVersionsList,
  getDashboardStats,
  getFrontlineUsersData,
  getFrontlineUsersList,
  exportFrontlineUsers,
  deleteUser,
  getNewRestaurantList,
  getRoleUsersList,
  getUserMainList,
  getUserTypeList,
  getVersionData,
  updateAdminUserStatus,
  updateUserStatus,
  updateVersionItem,
  uploadAdminUser,
  uploadFrontlineBulkUser,
  uploadFrontlineBulkUserAdmin,
  uploadFrontlineUser,
  addNotification,
  getNotificationList,
  deleteNotification,
  sendNotification,
  getNotifications,
  editNotification,
  uploadNotificationImage,
  addGiftCard,
  getGiftCardList,
  deleteGiftCard,
  getGiftCard,
  EditGiftCard,
  uploadGiftCardImage,
  getGamificationData,
  EditGamification,
  getEventData,
  addEvent,
  deleteEvent,
  getEventDetails,
  editEvent,
  addMenuImage,
  getMenuImage,
  uploadMenuImage,
  downloadMenuTemplate,
  getDynamicMenuFields,
  deleteMenuField,
  createDynamicMenuFields,
  editDynamicMenuFields,
  sendInvite,
  getUserRole,
  getRoleDetails,
  editRoleDetails,
  addRoleDetails,
  deleteRoleDetails,
  addMenuCategory,
  changeMenuOrder,
  getMenuCategoryDetails,
  editMenuCategoryDetails,
  deleteMenuCategory,
  getHeaderNotification,
  createHeaderNotification,
  getTilesList,
  createTile,
  enableDisableTiles,
  getTileDetails,
  updateTile,
  deleteTile,
  reorderTiles,
  getRecommendationCategoryList,
  getRecommendedCategoryDetails,
  updateRecommendedCategoryDetails,
  getWeeklyCategory,
  uploadWeeklyCategoryImage,
  addWeeklyCategoryImage,
  addWeeklyCategory,
  getAdvertisements,
  getAdvertisementDetails,
  addAdvertisements,
  updateAdvertisements,
  deleteAdvertisements,
  editWeeklyCategory,
  uploadPrivacyPolicyDocument,
  getPrivacyPolicy,
  getNotableVips,
  getNotableUsers,
  updateNotableUsers,
  getVipDetails,
  approveVip,
  uploadVipImage,
  createNotableVip,
  updateNotableVip,
  getNotableVipGroups,
  createNotableVipGroup,
  updateNotableVipGroup,
  deleteNotableVipGroup,
  getVipGroupDynamicFields,
  createVipGroupSection,
  updateVipGroupSection,
  deleteVipGroupSection,
  createVipGroupField,
  updateVipGroupField,
  deleteVipGroupField,
  reorderVipGroupSections,
  getNotableGroupTypes,
  getAvataarPrompt,
  updateAvataarPrompt,
  getVipGroupFields,
  deleteNotableVip,
  uploadRewardImage,
  getTiers,
  createTier,
  updateTier,
  deleteTier,
  updateTierOrder,
  getCategories,
  createCategory,
  updateCategory,
  deleteCategory,
  getCardTypes,
  getRewards,
  createReward,
  updateReward,
  deleteReward,
  reorderRewards,
  setRewardSpreeQuantity,
  getSpreeWindowQuantities,
  uploadGiftCardCoupons,
  getGiftCardRedemptions,
  getAllRedemptions,
  changeRedemptionStatus,
  getRewardState,
  updateRewardState,
  getAnalyticsSummary,
  exportAnalytics,
  getSectionTypes,
  createSectionType,
  getSectionTypeDetail,
  updateSectionType,
  deleteSectionType,
  createSectionField,
  updateSectionField,
  deleteSectionField,
  reorderSectionTypes,
  reorderSectionFields,
  getPreshifts,
  createPreshift,
  getPreshiftDetail,
  updatePreshift,
  deletePreshift,
  publishPreshift,
  unpublishPreshift,
  updatePreshiftSectionData,
  updateAllPreshiftSections,
  addItemsToSection,
  removeItemFromSection,
  uploadPreshiftMedia,
  reorderPreshiftSections,
  copyPreshift,
  secondApproveVip,
  getCMSRestaurantList,
  getCMSRestaurantDetail,
  createCMSRestaurant,
  updateCMSRestaurant,
  getCMSRestaurantGroupList,
  getCMSRestaurantGroupDetail,
  createCMSRestaurantGroup,
  updateCMSRestaurantGroup,
  getCMSUsersForAssignment,
  uploadCMSMedia,
  reorderCMSRestaurants,
  getRaffleWinners,
  updateRaffleWinnerPrizeClaimed,
  getVipCategories,
  getRewardsPermissions,
  updateRewardsPermissions,
  getShoppingSpreeWindows,
  createShoppingSpreeWindow,
  updateShoppingSpreeWindow,
  deleteShoppingSpreeWindow
} from "./user"

export default function* superAdminWatcher() {
  yield takeLatest(getUserTypeListAction, getUserTypeList)
  yield takeLatest(getFrontlineUsersListAction, getFrontlineUsersList)
  yield takeLatest(exportFrontlineUsersAction, exportFrontlineUsers)
  yield takeLatest(deleteUserAction, deleteUser)
  yield takeLatest(uploadFrontlineUserAction, uploadFrontlineUser)
  yield takeLatest(getFrontlineUsersDataAction, getFrontlineUsersData)
  yield takeLatest(EditFrontlineUsersDataAction, EditFrontlineUsersData)
  yield takeLatest(updateUserStatusAction, updateUserStatus)
  yield takeLatest(uploadFrontlineBulkUserAction, uploadFrontlineBulkUser)
  yield takeLatest(getAdminUsersListAction, getAdminUsersList)
  yield takeLatest(uploadAdminUserAction, uploadAdminUser)
  yield takeLatest(getUserMainListAction, getUserMainList)
  yield takeLatest(getRoleUsersListAction, getRoleUsersList)
  yield takeLatest(getNewRestaurantListAction, getNewRestaurantList)
  yield takeLatest(getAdminUsersDataAction, getAdminUsersData)
  yield takeLatest(EditAdminUsersDataAction, EditAdminUsersData)
  yield takeLatest(updateAdminUserStatusAction, updateAdminUserStatus)
  yield takeLatest(uploadFrontlineBulkUserAdminAction, uploadFrontlineBulkUserAdmin)
  yield takeLatest(getDashboardStatsAction, getDashboardStats)
  yield takeLatest(getVersionListAction, getAppVersionsList)
  yield takeLatest(addVersionAction, addVersionItems)
  yield takeLatest(getVersionDataAction, getVersionData)
  yield takeLatest(updateVersionAction, updateVersionItem)
  yield takeLatest(deleteVersionAction, deleteVersionItem)
  yield takeLatest(addNotificationAction, addNotification)
  yield takeLatest(getNotificationListAction, getNotificationList)
  yield takeLatest(deleteNotificationAction, deleteNotification)
  yield takeLatest(sendNotificationAction, sendNotification)
  yield takeLatest(getNotificationsAction, getNotifications)
  yield takeLatest(EditNotificationAction, editNotification)
  yield takeLatest(uploadNotificationImageAction, uploadNotificationImage)
  yield takeLatest(addGiftCardAction, addGiftCard)
  yield takeLatest(getGiftCardListAction, getGiftCardList)
  yield takeLatest(deleteGiftCardAction, deleteGiftCard)
  yield takeLatest(getGiftCardsAction, getGiftCard)
  yield takeLatest(EditGiftCardAction, EditGiftCard)
  yield takeLatest(uploadGiftCardImageAction, uploadGiftCardImage)
  yield takeLatest(getGamificationDataAction, getGamificationData)
  yield takeLatest(EditGamificationAction, EditGamification)
  yield takeLatest(getEventDataAction, getEventData)
  yield takeLatest(addEventAction, addEvent)
  yield takeLatest(deleteEventAction, deleteEvent)
  yield takeLatest(getEventDetailsAction, getEventDetails)
  yield takeLatest(editEventAction, editEvent)
  yield takeLatest(addMenuImageAction, addMenuImage)
  yield takeLatest(getMenuImageAction, getMenuImage)
  yield takeLatest(uploadMenuImageAction, uploadMenuImage)
  yield takeLatest(downloadMenuTemplateAction, downloadMenuTemplate)
  yield takeLatest(getDynamicMenuFieldsAction, getDynamicMenuFields)
  yield takeLatest(deleteMenuFieldAction, deleteMenuField)
  yield takeLatest(createDynamicMenuFieldsAction, createDynamicMenuFields)
  yield takeLatest(editDynamicMenuFieldsAction, editDynamicMenuFields)
  yield takeLatest(sendInviteAction, sendInvite)
  yield takeLatest(getUserRoleAction, getUserRole)
  yield takeLatest(getRoleDetailsAction, getRoleDetails)
  yield takeLatest(editRoleDetailsAction, editRoleDetails)
  yield takeLatest(addRoleDetailsAction, addRoleDetails)
  yield takeLatest(deleteRoleDetailsAction, deleteRoleDetails)
  yield takeLatest(addMenuCategoryAction, addMenuCategory)
  yield takeLatest(changeMenuOrderAction, changeMenuOrder)
  yield takeLatest(getMenuCategoryDetailsAction, getMenuCategoryDetails)
  yield takeLatest(editMenuCategoryDetailsAction, editMenuCategoryDetails)
  yield takeLatest(deleteMenuCategoryAction, deleteMenuCategory)
  yield takeLatest(getRecommendationCategoryListAction, getRecommendationCategoryList)
  yield takeLatest(updateRecommendationCategoryDetailsAction, updateRecommendedCategoryDetails)
  yield takeLatest(getRecommendedCategoryDetailsAction, getRecommendedCategoryDetails)
  yield takeLatest(getHeaderNotificationAction, getHeaderNotification)
  yield takeLatest(createHeaderNotificationAction, createHeaderNotification)
  yield takeLatest(getTilesListAction, getTilesList)
  yield takeLatest(createTileAction, createTile)
  yield takeLatest(updateTileAction, updateTile)
  yield takeLatest(deleteTileAction, deleteTile)
  yield takeLatest(reorderTilesAction, reorderTiles)
  yield takeLatest(getTileDetailsAction, getTileDetails)
  yield takeLatest(enableDisableTilesAction, enableDisableTiles)
  yield takeLatest(getWeeklyCategoryAction, getWeeklyCategory)
  yield takeLatest(uploadWeeklyCategoryImageAction, uploadWeeklyCategoryImage)
  yield takeLatest(addWeeklyCategoryImageAction, addWeeklyCategoryImage)
  yield takeLatest(addWeeklyCategoryAction, addWeeklyCategory)
  yield takeLatest(editWeeklyCategoryAction, editWeeklyCategory)
  yield takeLatest(getAdvertisementsAction, getAdvertisements)
  yield takeLatest(getAdvertisementDetailsAction, getAdvertisementDetails)
  yield takeLatest(addAdvertisementsAction, addAdvertisements)
  yield takeLatest(updateAdvertisementsAction, updateAdvertisements)
  yield takeLatest(deleteAdvertisementsAction, deleteAdvertisements)
  yield takeLatest(uploadPrivacyPolicyDocumentAction, uploadPrivacyPolicyDocument)
  yield takeLatest(getPrivacyPolicyAction, getPrivacyPolicy)
  yield takeLatest(getNotableVipsAction, getNotableVips)
  yield takeLatest(getNotableUsersAction, getNotableUsers)
  yield takeLatest(updateNotableUsersAction, updateNotableUsers)
  yield takeLatest(getVipDetailsAction, getVipDetails)
  yield takeLatest(approveVipAction, approveVip)
  yield takeLatest(secondApproveVipAction, secondApproveVip)
  yield takeLatest(uploadVipImageAction, uploadVipImage)
  yield takeLatest(createNotableVipAction, createNotableVip)
  yield takeLatest(updateNotableVipAction, updateNotableVip)
  yield takeLatest(getNotableVipGroupsAction, getNotableVipGroups)
  yield takeLatest(createNotableVipGroupAction, createNotableVipGroup)
  yield takeLatest(updateNotableVipGroupAction, updateNotableVipGroup)
  yield takeLatest(deleteNotableVipGroupAction, deleteNotableVipGroup)
  yield takeLatest(getVipGroupDynamicFieldsAction, getVipGroupDynamicFields)
  yield takeLatest(createVipGroupSectionAction, createVipGroupSection)
  yield takeLatest(updateVipGroupSectionAction, updateVipGroupSection)
  yield takeLatest(deleteVipGroupSectionAction, deleteVipGroupSection)
  yield takeLatest(createVipGroupFieldAction, createVipGroupField)
  yield takeLatest(updateVipGroupFieldAction, updateVipGroupField)
  yield takeLatest(deleteVipGroupFieldAction, deleteVipGroupField)
  yield takeLatest(reorderVipGroupSectionsAction, reorderVipGroupSections)
  yield takeLatest(getNotableGroupTypesAction, getNotableGroupTypes)
  yield takeLatest(getAvataarPromptAction, getAvataarPrompt)
  yield takeLatest(updateAvataarPromptAction, updateAvataarPrompt)
  yield takeLatest(getVipGroupFieldsAction, getVipGroupFields)
  yield takeLatest(deleteNotableVipAction, deleteNotableVip)
  yield takeLatest(uploadRewardImageAction, uploadRewardImage)
  yield takeLatest(getTiersAction, getTiers)
  yield takeLatest(createTierAction, createTier)
  yield takeLatest(updateTierAction, updateTier)
  yield takeLatest(deleteTierAction, deleteTier)
  yield takeLatest(updateTierOrderAction, updateTierOrder)
  yield takeLatest(getCategoriesAction, getCategories)
  yield takeLatest(createCategoryAction, createCategory)
  yield takeLatest(updateCategoryAction, updateCategory)
  yield takeLatest(deleteCategoryAction, deleteCategory)
  yield takeLatest(getCardTypesAction, getCardTypes)
  yield takeLatest(getRewardsAction, getRewards)
  yield takeLatest(createRewardAction, createReward)
  yield takeLatest(updateRewardAction, updateReward)
  yield takeLatest(deleteRewardAction, deleteReward)
  yield takeLatest(reorderRewardsAction, reorderRewards)
  yield takeLatest(setRewardSpreeQuantityAction, setRewardSpreeQuantity)
  yield takeLatest(getSpreeWindowQuantitiesAction, getSpreeWindowQuantities)
  yield takeLatest(uploadGiftCardCouponsAction, uploadGiftCardCoupons)
  yield takeLatest(getGiftCardRedemptionsAction, getGiftCardRedemptions)
  yield takeLatest(getAllRedemptionsAction, getAllRedemptions)
  yield takeLatest(changeRedemptionStatusAction, changeRedemptionStatus)
  yield takeLatest(getRewardStateAction, getRewardState)
  yield takeLatest(updateRewardStateAction, updateRewardState)
  yield takeLatest(getAnalyticsSummaryAction, getAnalyticsSummary)
  yield takeLatest(exportAnalyticsAction, exportAnalytics)
  yield takeLatest(getSectionTypesAction, getSectionTypes)
  yield takeLatest(createSectionTypeAction, createSectionType)
  yield takeLatest(getSectionTypeDetailAction, getSectionTypeDetail)
  yield takeLatest(updateSectionTypeAction, updateSectionType)
  yield takeLatest(deleteSectionTypeAction, deleteSectionType)
  yield takeLatest(createSectionFieldAction, createSectionField)
  yield takeLatest(updateSectionFieldAction, updateSectionField)
  yield takeLatest(deleteSectionFieldAction, deleteSectionField)
  yield takeLatest(reorderSectionTypesAction, reorderSectionTypes)
  yield takeLatest(reorderSectionFieldsAction, reorderSectionFields)
  yield takeLatest(getPreshiftsAction, getPreshifts)
  yield takeLatest(createPreshiftAction, createPreshift)
  yield takeLatest(getPreshiftDetailAction, getPreshiftDetail)
  yield takeLatest(updatePreshiftAction, updatePreshift)
  yield takeLatest(deletePreshiftAction, deletePreshift)
  yield takeLatest(publishPreshiftAction, publishPreshift)
  yield takeLatest(unpublishPreshiftAction, unpublishPreshift)
  yield takeLatest(updatePreshiftSectionDataAction, updatePreshiftSectionData)
  yield takeLatest(updateAllPreshiftSectionsAction, updateAllPreshiftSections)
  yield takeLatest(addItemsToSectionAction, addItemsToSection)
  yield takeLatest(removeItemFromSectionAction, removeItemFromSection)
  yield takeLatest(uploadPreshiftMediaAction, uploadPreshiftMedia)
  yield takeLatest(reorderPreshiftSectionsAction, reorderPreshiftSections)
  yield takeLatest(copyPreshiftAction, copyPreshift)
  yield takeLatest(getCMSRestaurantListAction, getCMSRestaurantList)
  yield takeLatest(getCMSRestaurantDetailAction, getCMSRestaurantDetail)
  yield takeLatest(createCMSRestaurantAction, createCMSRestaurant)
  yield takeLatest(updateCMSRestaurantAction, updateCMSRestaurant)
  yield takeLatest(getCMSRestaurantGroupListAction, getCMSRestaurantGroupList)
  yield takeLatest(getCMSRestaurantGroupDetailAction, getCMSRestaurantGroupDetail)
  yield takeLatest(createCMSRestaurantGroupAction, createCMSRestaurantGroup)
  yield takeLatest(updateCMSRestaurantGroupAction, updateCMSRestaurantGroup)
  yield takeLatest(getCMSUsersForAssignmentAction, getCMSUsersForAssignment)
  yield takeLatest(uploadCMSMediaAction, uploadCMSMedia)
  yield takeLatest(reorderCMSRestaurantsAction, reorderCMSRestaurants)
  yield takeLatest(getRaffleWinnersAction, getRaffleWinners)
  yield takeLatest(updateRaffleWinnerPrizeClaimedAction, updateRaffleWinnerPrizeClaimed)
  yield takeLatest(getVipCategoriesAction, getVipCategories)
  yield takeLatest(getRewardsPermissionsAction, getRewardsPermissions)
  yield takeLatest(updateRewardsPermissionsAction, updateRewardsPermissions)
  yield takeLatest(getShoppingSpreeWindowsAction, getShoppingSpreeWindows)
  yield takeLatest(createShoppingSpreeWindowAction, createShoppingSpreeWindow)
  yield takeLatest(updateShoppingSpreeWindowAction, updateShoppingSpreeWindow)
  yield takeLatest(deleteShoppingSpreeWindowAction, deleteShoppingSpreeWindow)
}
